module.exports = __webpack_public_path__ + "img/search-hotspot.0721a169.png";